/* 
 * To change this template, choose Tools | Templates
 * and open the template in the editor.
 */
if(!window.GS) GS={};
if(!window.GS.Filters) GS.Filters={};

GS.Filters.BaseFilter=new Class({
    Extends: GS.BaseClass,
    class_name:'GS.Filters.BaseFilter',
    options:{
        'debug':0,
        'colors':{},
        'shadow':{},
        'prefix':''
    },
    filter: {
        'id':0,
        'container':null
    },
    defs:null,
    paper:null,
    initialize:function(paper,conf){
        
        this.parent(conf);
        this.setup(paper);
        this.createFilter();
        this.addFixedFilters();
    }
});

/**
 * Setup filter instance....
 * @param {SVGElement} paper
 * @returns {void}
 */
GS.Filters.BaseFilter.prototype.setup=function(paper){
    var self=this;
    var svg=paper.canvas;
    this.options.prefix=paper.canvas.getAttribute('id');
    if(!this.options.prefix) this.options.prefix='';
    this.defs=svg.getElement('defs');
    if(!this.defs) this.defs=new Element('defs');
    this.setFilterUID();

};

GS.Filters.BaseFilter.prototype.addPersonalizationFilters = function(type){
    var xmlns,vals, f;
    xmlns = "http://www.w3.org/2000/svg";
    vals = '1 1';
    switch(type){
        case 'transparent':
            vals = '0 1';
            break;
        case 'black':
            vals = '0 0';
            break;
        case 'gray':
            vals = '0.9 0.9';
            break;
    }

    f = document.createElementNS(xmlns, "filter");
    f.setAttribute('id',type);
    f.setAttribute('x','0');
    f.setAttribute('y','0');
    f.setAttribute('width','200%');
    f.setAttribute('height','200%');
    f.innerHTML = '<feComponentTransfer in="SourceGraphic">\n' +
        '                <feFuncR type="table" tableValues="'+vals+'"></feFuncR>\n' +
        '                <feFuncG type="table" tableValues="'+vals+'"></feFuncG>\n' +
        '                <feFuncB type="table" tableValues="'+vals+'"></feFuncB>\n' +
        '            </feComponentTransfer>';

    if(type === 'white') f.innerHTML = '<feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 1  0 0 0 0 1  0 0 0 0 1  0 0 0 2 0" result="w"></feColorMatrix>';
    this.defs.appendChild(f);
}


GS.Filters.BaseFilter.prototype.addFixedFilters = function (){
    var _laser, _laserID, _impHotID, _impID, _prefix, _laser_graphic, _laser_frame, _laser_frame_png, _laser_frameID, _laser_frame_pngID, _laser_graphicID, _impression, _impression_hot, _invert_filter, _invertID;
    _prefix =  this.options.prefix.test(/^artboard/) ? this.options.prefix : 'thumbnail';
    _laserID = _prefix +'_laser';
    _laser_frameID = _prefix +'_laser_frame';
    _laser_frame_pngID = _prefix +'_laser_frame_png';
    _laser_graphicID = _prefix +'_laser_graphic';
    _impID = _prefix +'_impression';
    _impHotID = _prefix +'_impression_hot';
    _invertID = _prefix +'_invert';
    _laser = this.defs.querySelector('#'+_laserID);
    _laser_frame = this.defs.querySelector('#'+_laser_frameID);
    _laser_frame_png = this.defs.querySelector('#'+_laser_frame_pngID);
    _laser_graphic = this.defs.querySelector('#'+_laser_graphicID);
    _impression = this.defs.querySelector('#'+_impID);
    _impression_hot = this.defs.querySelector('#'+_impHotID);
    _invert_filter = this.defs.querySelector('#'+_invertID);


    this.addPersonalizationFilters('white');
    this.addPersonalizationFilters('black');
    this.addPersonalizationFilters('gray');
    this.addPersonalizationFilters('transparent');

    if(!_impression){
        // ADD IMPRESSION FILTER
        _impression = new Element('filter',  {'id': _impID });
        _impression.innerHTML = '' +
            '    <feDiffuseLighting in="SourceGraphic" result="light" lighting-color="white" surfaceScale="5" specularConstant="10">' +
            '      <fePointLight x="0" y="150" z="200" />' +
            '    </feDiffuseLighting>\n' +
            '    <feComposite in2="SourceAlpha" in="light" operator="in" result="light" />' +
            '    <feComponentTransfer in="light" result="light">' +
            '      <feFuncA type="linear" slope="0.2"/>' +
            '    </feComponentTransfer>' +
            '    <feGaussianBlur in="light" result="blur" stdDeviation="0.8"></feGaussianBlur>'+
            '     <feMerge>' +
            '       <feMergeNode in="blur"/>' +
            '       <feMergeNode in="light"/>' +
            '  </feMerge>';
        this.defs.appendChild(_impression);
        this.register('impression:getfilter:id', function(cb) {
            if(cb) cb(_impID);
        });
    }

    if(!_impression_hot) {
        // ADD IMPRESSION HOT TEXT FILTER
        _impression_hot =  new Element('filter',  {'id': _impHotID });
        _impression_hot.innerHTML = ''+
            '<feDiffuseLighting in="SourceGraphic" result="light" lighting-color="white" surfaceScale="5" specularConstant="10">' +
            '      <fePointLight x="0" y="150" z="200" />' +
            '    </feDiffuseLighting>' +
            '    <feComposite in2="SourceAlpha" in="light" operator="in" result="light" />' +
            '    <feComponentTransfer in="light" result="light">' +
            '      <feFuncA type="linear" slope="0.2"/>' +
            '    </feComponentTransfer>' +
            '    <feBlend in="SourceGraphic" in2="light" mode="multiply"/>'+
            '    <feGaussianBlur in="SourceGraphic" result="blur" stdDeviation="0.6"></feGaussianBlur>'+
            '    <feComponentTransfer in="blur" result="blur">' +
            '       <feFuncA type="linear" slope="0.5"></feFuncA>'+
            '    </feComponentTransfer>'+
            '    <feBlend in="SourceGraphic" in2="light" result="light" mode="multiply"></feBlend>' +
            '     <feMerge>' +
            '       <feMergeNode in="blur"/>' +
            '       <feMergeNode in="light"/>' +
            '  </feMerge>';
        this.defs.appendChild(_impression_hot);
        this.register('impression_hot:getfilter:id', function(cb) {
            if(cb) cb(_impHotID);
        });
    }

    if(!_laser) {
        // ADD LASER FILTER
        _laser = new Element('filter', {'id': _laserID});
        _laser.innerHTML = ''+
         '<feDiffuseLighting in="SourceGraphic" result="light" lighting-color="white" surfaceScale="1" specularConstant="5">\n' +
            '      <fePointLight x="0" y="150" z="30" />\n' +
            '    </feDiffuseLighting>\n' +
            '    <feComposite in2="SourceAlpha" in="light" operator="in" result="light" />\n' +
            '    <feComponentTransfer in="light">\n' +
            '      <feFuncA type="linear" slope="0.4"/>\n' +
            '    </feComponentTransfer>';
        this.defs.appendChild(_laser);
        this.register('laser:getfilter:id', function(cb) {
            if(cb) cb(_laserID);
        });
        //console.log('ADD ENGRAVING FILTER!');
    }

    if(!_laser_frame){
        _laser_frame = new Element('filter', {'id': _laser_frameID});
        _laser_frame.innerHTML = ''+
            '   <feColorMatrix in="SourceGraphic" type="luminanceToAlpha" result="luminance"/>' +
            //'   <feConvolveMatrix in="luminance" kernelMatrix="-2 -1 0 -1 1 1 0 1 2" preserveAlpha="false"/>';
            '   <feConvolveMatrix in="luminance" result="luminance" kernelMatrix="-1.5 0 0 0 0 0 0 0 1.5" preserveAlpha="false"/>'+
            '   <feComponentTransfer in="luminance">' +
            '      <feFuncA type="linear" slope="0.8"/>' +
            '   </feComponentTransfer>';
        this.defs.appendChild(_laser_frame);
        this.register('laser_frame:getfilter:id', function(cb) {
            if(cb) cb(_laser_frameID);
        });
    }

    if(!_laser_frame_png){
        _laser_frame_png = new Element('filter', {'id': _laser_frame_pngID});
        _laser_frame_png.innerHTML = `

                <!-- Shadow offset --><feOffset dx="0" dy="0.2" result="offset"></feOffset>

                <!-- Shadow blur -->
                <feGaussianBlur stdDeviation="0.2" result="offset-blur" in="offset"></feGaussianBlur>

                <!-- Invert drop shadow to make an inset shadow -->
                <feComposite operator="out" in="SourceAlpha" in2="offset-blur" result="inverse"></feComposite>

                <!-- Cut color inside shadow -->
                <feFlood flood-color="#000" flood-opacity="1" result="color"></feFlood>
                <feComposite result="shadow" in2="inverse" in="color" operator="in"></feComposite>

                <!-- Placing shadow over element -->
                <feComposite operator="in" in="shadow" in2="SourceAlpha" result="shadow"></feComposite>

                <feFlood flood-color="#000" flood-opacity="0.9" result="bg"></feFlood>

                <feComposite operator="out" in="SourceAlpha" in2="bg" result="bg"></feComposite>
                <feBlend mode="multiply" in="shadow" in2="bg"></feBlend>
        
        `;

        this.defs.appendChild(_laser_frame_png);
        this.register('laser_frame_png:getfilter:id', function(cb) {
            if(cb) cb(_laser_frame_pngID);
        });
    }

    if(!_laser_graphic){
        _laser_graphic = new Element('filter', {'id': _laser_graphicID});
        /*_laser_graphic.innerHTML = ''+
            //'   <feColorMatrix in="SourceGraphic" type="luminanceToAlpha" result="luminance"/>' +
            //'   <feConvolveMatrix in="luminance" kernelMatrix="-2 -1 0 -1 1 1 0 1 2" preserveAlpha="false"/>';
            '   <feConvolveMatrix in="SourceAlpha" result="luminance" kernelMatrix="-1 0 0 0 0 0 0 0 1" preserveAlpha="false"/>'+
            '   <feComponentTransfer in="luminance">' +
            //'      <feFuncA type="table" tableValues="0.5 0.5 0.5"/>' +
            '      <feFuncA type="linear" slope="0.5"/>' +
            '   </feComponentTransfer>';*/

        _laser_graphic.innerHTML = ''+
           '<feColorMatrix in="SourcAlpha" type="luminanceToAlpha" result="luminance"></feColorMatrix>' +
            '            <feComponentTransfer in="luminance" result="luminance">' +
            '                <feFuncA type="table" tableValues="1 0"></feFuncA>' +
            '            </feComponentTransfer>' +
            '            <feComponentTransfer in="luminance" result="luminance">' +
            '                <feFuncA type="table" tableValues="1 1 0"></feFuncA>' +
            '            </feComponentTransfer>' +
            '            <feComposite in2="SourceAlpha" in="luminance" operator="in" result="luminance"></feComposite>' +
            '            <feConvolveMatrix in="luminance" result="luminance" kernelMatrix="-0.5 0 0 0 0 0 0 0 0.5"></feConvolveMatrix>'
        this.defs.appendChild(_laser_graphic);
        this.register('laser_graphic:getfilter:id', function(cb) {
            if(cb) cb(_laser_graphicID);
        });

        var t;
        t = new Element('filter', {'id': 'my_impression_test'});
        t.innerHTML = '<feColorMatrix in="SourcAlpha" type="luminanceToAlpha" result="luminance"></feColorMatrix>            <feComponentTransfer in="luminance" result="luminance">                <feFuncA type="table" tableValues="1 0"></feFuncA>            </feComponentTransfer>            <feComponentTransfer in="luminance" result="luminance">                <feFuncA type="table" tableValues="0.5 0.1 0"></feFuncA>            </feComponentTransfer>            <feComposite in2="SourceAlpha" in="luminance" operator="in" result="luminance"></feComposite>            <feConvolveMatrix in="luminance" kernelMatrix="-1 0 0 -0.3 0.1 0 0 -0.1 1"></feConvolveMatrix>'
        this.defs.appendChild(t);
    }

    if(!_invert_filter){
        var t = new Element('filter', {'id': _invertID});
        t.innerHTML = '<feColorMatrix in="SourceGraphic" type="matrix" values="-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0"/>';
        this.defs.appendChild(t);
    }

};

/**
 * Apply/Attach filter to element
 * @param {SVG Element} ele
 * @returns {void}
 */
GS.Filters.BaseFilter.prototype.applyTo=function(ele){
    
    //ele.node.style['filter']="url('#"+this.filter.id+"')";
    (ele.node || ele).setAttribute('filter',"url('#"+this.filter.id+"')");
    //ele.node.style['-webkit-filter']="url('#"+this.filter.id+"')";
};

GS.Filters.BaseFilter.prototype.removeFrom=function(ele){

    //ele.node.style['filter']="url('#"+this.filter.id+"')";
    (ele.node || ele).removeAttribute('filter');
    //ele.node.style['-webkit-filter']="url('#"+this.filter.id+"')";
};

/**
 * Updating filters....
 * @param {object} obj
 * @returns {undefined}
 */
GS.Filters.BaseFilter.prototype.update=function(obj){
    this.console.warn('You mast Override this method to create your own Filter/Pattern Update!');
    //Update shadow filter....
    /*this.filter.offset.setAttribute('dx',obj.shadow.dx);
    this.filter.offset.setAttribute('dy',obj.shadow.dy);
    this.filter.blur.setAttribute('stdDeviation',obj.shadow.blur);
    var cMatrix;
    if(!obj.shadow.display){
        cMatrix="0 0 0 {r} 0 0 0 0 {g} 0 0 0 0 {b} 0 0 0 0 0 0".substitute(obj.shadow.color);
    }else{
        cMatrix="0 0 0 {r} 0 0 0 0 {g} 0 0 0 0 {b} 0 0 0 0 {a} 0".substitute(obj.shadow.color);
    }
   
    this.filter.color.setAttribute("values",cMatrix);
    
    
    //Update color filters....
    this.setImageBrightness(obj.colors.brightness);
    this.setImageContrast(obj.colors.contrast);
    this.setImageSaturation(obj.colors.saturation)
    this.convertToSepia(obj.colors.sepia)
    
    this.filter.saturation.set('values',this.options.colors.saturation_matrix.join(' '));
    this.filter.brightness.set('values',this.options.colors.brightness_matrix.join(' '));
    this.filter.contrast.set('values',this.options.colors.contrast_matrix.join(' '));
    this.filter.sepia.set('values',this.options.colors.sepia_matrix.join(' '));*/
};

/**
 * Setting Unique Filter ID
 * @returns {void}
 */
GS.Filters.BaseFilter.prototype.setFilterUID=function(){
    var f=this.filter;
    var prefix=this.options.prefix;
    this.dispatch('filter:uid',function(uid){
        f.id=prefix+'_'+uid;
    });
};

GS.Filters.BaseFilter.prototype.createFilter=function(){
    this.console.warn('You mast Override this method to create your own Filter Effect!');
    /*return;
    var f=new Element('filter',{'id':this.filter.id,'x':'-300%','y':'-300%','width':'600%','height':'600%','enable-background':'accumulate','color-interpolation-filters':'sRGB'});
    this.filter.container=f;
    
    this.addColorFilter();
    this.addShadowFilter();
    this.defs.adopt(f);*/
};

/**
 * @deprecated
 **/
GS.Filters.BaseFilter.prototype.toString=function(){
    var obj={
        'shadow':Object.clone(this.options.shadow),
        'colors':Object.clone(this.options.colors)
    };
    return JSON.encode(obj);
};

/**
* Create Shadow Filter element     
* @returns {void}
*/
/*
GS.Filters.BaseFilter.prototype.addShadowFilter=function(){
    var fID,feGaussianBlur,feOffset,cMatrix,feColorMatrix,
    feMerge,feMergeShadow,feMergeSurce;
    
    //Add Gaussian Blur Filter
    feGaussianBlur = new Element('feGaussianBlur',{'in':'SourceAlpha','result':'blur','stdDeviation':this.options.shadow.blur});
    this.filter.blur=feGaussianBlur;
    
    //Add Offset Filter
    feOffset = new Element('feOffset',{'in':'blur','result':'shadow','dx':this.options.shadow.dx,'dy':this.options.shadow.dy});
    this.filter.offset=feOffset;
    
    //Add Color Matrix Filter
    if(!this.options.shadow.display){
        cMatrix="0 0 0 {r} 0 0 0 0 {g} 0 0 0 0 {b} 0 0 0 0 {a} 0".substitute(this.options.shadow.color);
    }else{
        cMatrix="0 0 0 {r} 0 0 0 0 {g} 0 0 0 0 {b} 0 0 0 0 {a} 0".substitute(this.options.shadow.color);
    }
    feColorMatrix = new Element('feColorMatrix',{'in':'shadow','result':'cloredShadow','type':'matrix','values':cMatrix});
    this.filter.color=feColorMatrix;
    
    //Merging Filters
    feMerge = new Element('feMerge');
    feMergeShadow = new Element('feMergeNode',{'in':'cloredShadow','mode':'normal'});
    feMergeSurce = new Element('feMergeNode',{'in':'composit','mode':'normal'});
    feMerge.adopt([feMergeShadow,feMergeSurce]);
    this.filter.container.adopt([feGaussianBlur,feOffset,feColorMatrix,feMerge]);

};*/

/**
* Create Color Filter element     
* @returns {void}
*/
/*
GS.Filters.BaseFilter.prototype.addColorFilter=function(){
    var fID,saturation,brightness,contrast,sepia,feMerge,feMergeComposit;
    
    saturation = new Element('feColorMatrix',{'in':'SourceGraphic','type':'matrix','result':'saturated','values':'1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0'});
    this.setImageSaturation(this.options.colors.saturation);
    saturation.set('values',this.options.colors.saturation_matrix.join(' '));
    this.filter.saturation=saturation;
    
    brightness = new Element('feColorMatrix',{'in':'saturated','type':'matrix','result':'brightness','values':'1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0'});
    this.setImageBrightness(this.options.colors.brightness);
    brightness.set('values',this.options.colors.brightness_matrix.join(' '));
    this.filter.brightness=brightness;
    
    contrast = new Element('feColorMatrix',{'in':'brightness','type':'matrix','result':'composit','values':''});
    this.setImageContrast(this.options.colors.contrast);
    contrast.set('values',this.options.colors.contrast_matrix.join(' '));
    this.filter.contrast=contrast;
    
    sepia = new Element('feColorMatrix',{'in':'composit','type':'matrix','values':''});
    this.convertToSepia(this.options.colors.sepia);
    sepia.set('values',this.options.colors.sepia_matrix.join(' '));
    this.filter.sepia=sepia;
    

    feMerge = new Element('feMerge');
    feMergeComposit = new Element('feMergeNode',{'in':'composit','mode':'normal'});
    feMerge.adopt(feMergeComposit);
    
    this.filter.container.adopt([saturation,,brightness,contrast,sepia]);
};*/

/**
* Add sepia filter
* @param {type} v       
* @returns {void}
*/
/*
GS.Filters.BaseFilter.prototype.convertToSepia=function(v){
    var cMatrix = [];
    var r=(v) ? 0.14 : 1;
    var g=(v) ? 0.39 : 1;
    var b=(v) ? 0.03 : 1;

    var rx=(v) ? 0.45 : 0;
    var ry=(v) ? 0.05 : 0;

    var gx=(v) ? 0.12 : 0;
    var gy=(v) ? 0.04 : 0;

    var bx=(v) ? 0.08 : 0;
    var by=(v) ? 0.28 : 0;

    cMatrix = cMatrix.concat([r , rx, ry, 0, 0]);   // red
    cMatrix = cMatrix.concat([gx, g, gy, 0, 0]);    // green
    cMatrix = cMatrix.concat([bx, by, b, 0, 0]);    // blue
    cMatrix = cMatrix.concat([0, 0, 0, 1, 0]);      // alpha 
    this.options.colors.sepia_matrix=cMatrix;
 }*/

/**
* Change image saturation
* @param {type} v          :[-100,100] default to 0
* @returns {void}
*/

/*
GS.Filters.BaseFilter.prototype.setImageSaturation=function(v){
    var cMatrix = [],lumaR,lumaG,lumaB,i,r,g,b;
    lumaR = 0.212671;
    lumaG = 0.71516;
    lumaB = 0.072169;
    v=v/100+1

    i = (1 - v);
    r = (i * lumaR);
    g = (i * lumaG);
    b = (i * lumaB);

    cMatrix = cMatrix.concat([(r + v), g, b, 0, 0]);    // red
    cMatrix = cMatrix.concat([r, (g + v), b, 0, 0]);    // green
    cMatrix = cMatrix.concat([r, g, (b + v), 0, 0]);    // blue
    cMatrix = cMatrix.concat([0, 0, 0, 1, 0]);          // alpha
    
    this.options.colors.saturation_matrix=cMatrix;
};*/

/**
* Set image Brightness
* @param {Number} s
* @returns {void}
*/
/*
GS.Filters.BaseFilter.prototype.setImageBrightness=function(s){
    var cMatrix=[];
    s=-Number(s)/100;

    cMatrix=cMatrix.concat([1,0,0,0,s]);// red
    cMatrix=cMatrix.concat([0,1,0,0,s]);// green
    cMatrix=cMatrix.concat([0,0,1,0,s]);// blue
    cMatrix=cMatrix.concat([0,0,0,1,0]);// alpha
    
    this.options.colors.brightness_matrix=cMatrix;
}*/

/**
* Set the image contrast
* 
* @param {Number} v          :[-100,100] default to 0
* @returns {void}
*/
/*
GS.Filters.BaseFilter.prototype.setImageContrast=function(v){
    var cMatrix=[],s_d;
    v=Number(v);
    v /= 100;

    s = v + 1;
    _d = 0.5*(1 - s);

    cMatrix = cMatrix.concat([s, 0, 0, 0, _d]);  // red
    cMatrix = cMatrix.concat([0, s, 0, 0, _d]);  // green
    cMatrix = cMatrix.concat([0, 0, s, 0, _d]);  // blue
    cMatrix = cMatrix.concat([0, 0, 0, 1, 0]);  // alpha

    this.options.colors.contrast_matrix=cMatrix;
};*/